import http from '../httpService';
import {BASE_URL, token} from '../../utils/const';
import * as Axios from 'axios';

export function getAllMeasures(id) {
  return http.get(`/measures?riskId.equals=${id}`);
}

export function getMeasure(id) {
  return http.get(`/measures/${id}`);
}

export function updateMeasure(measuresData, files) {
  const formData = new FormData();
  formData.append('measuresDTO', JSON.stringify(measuresData));
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }

  return Axios({
    method: 'put',
    url: '/measures',
    data: formData,
    headers: {'Content-Type': 'multipart/form-data'},
  });
}

export function addMeasure(measuresData, files) {
  const formData = new FormData();
  formData.append('measuresDTO', JSON.stringify(measuresData));
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }

  return Axios({
    method: 'post',
    url: '/measures',
    data: formData,
    headers: {'Content-Type': 'multipart/form-data'},
  });
}

export function getAllAppliedMeasureResults(id) {
  return http.get(`/applied-measure-results?measuresId.equals=${id}`);
}

export function getRiskData(id) {
  return http.get(`risks/${id}`);
}

export function verifyMeasure(id, data) {
  return http.put(
    `measures/verify?measuresId=${id}`, data
  );
}

export function getMeasureFile(fileId, fileName) {
  return Axios({
    url: `/file/download/${fileId}`, //your url
    method: 'get',
    responseType: 'blob', // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    // link.target = "_blank"
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  });
}